export default __webpack_public_path__ + "static/media/b11.135ba51c.jpg";